import React, { useState, useRef, useEffect } from 'react';
import { FiUsers, FiClock } from "react-icons/fi";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Avatar from 'react-avatar';
import { getAuthorEmailFilter } from "../../../../../store/actions/cms/scheduler";
import { useDispatch, useSelector } from "react-redux";

export default function CustomDropdown({ type = 'user', selectedValues = [], onChange,userLimit }) {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const dropdownRef = useRef(null);
    const debounceRef = useRef(null);

    const { authorEmailData,authorEmailLoading } = useSelector((state) => state?.contentSchedularReducer || {});

    const handleSearch = (term) => {
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            if (term?.trim()) {
                dispatch(getAuthorEmailFilter({ filter_type: 'user_email', term: term.trim() }));
            }
        }, 500);
    };

    // close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpen(false);
                setSearchTerm('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleSelect = (option) => {
        let updated;
        if (selectedValues?.some(v => v.user_id === option.user_id)) {
            updated = selectedValues?.filter(v => v.user_id !== option.user_id);
        } else {
            if (selectedValues.length >= userLimit) { 
                //not let the user to select more then userLimit, validation msg is handled in parent
                return;
            }
            updated = [...selectedValues, option];
        }
        onChange(updated);
    };

    const isSelected = (option) => {
        return selectedValues?.some(v => v.user_id === option.user_id);
    };

    return (
        <div ref={dropdownRef} style={{ position: 'relative' }}>
            {/* Control */}
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: open ? '#fff' : '#f3f6fb',
                    borderRadius: '100px',
                    border: open ? '1px solid #2684ff' : 'none',
                    minHeight: '40px',
                    cursor: 'pointer',
                    paddingLeft: '38px',
                    paddingRight: '32px'
                }}
            >
                {/* Left icon */}
                {type !== 'user' ? (
                    <FiClock size={18} style={{ position: 'absolute', left: '12px', color: '#555' }} />
                ) : (
                    <FiUsers size={18} style={{ position: 'absolute', left: '12px', color: '#555' }} />
                )}

                {/* Search Input */}
                <input
                    placeholder='Add User'
                    value={searchTerm}
                    onChange={(e) => {
                        const term = e.target.value;
                        setSearchTerm(term);
                        handleSearch(term);
                        if (!open) setOpen(true);//to open options
                    }}
                    onClick={() => setOpen(prev => !prev)}
                    onFocus={()=>dispatch(getAuthorEmailFilter({ filter_type: 'user_email'}))}
                    style={{
                        border: 'none',
                        outline: 'none',
                        background: 'transparent',
                        width: '100%',
                        fontSize: '14px',
                        color: '#404040'
                    }}
                />

                {/* Toggle Arrow */}
                {open ? (
                    <IoIosArrowUp
                        size={18}
                        style={{ position: 'absolute', right: '10px', color: '#555' }}
                        onClick={(e) => { e.stopPropagation(); setOpen(false); }}
                    />
                ) : authorEmailLoading ? (
                    <div
                        className="spinner-border spinner-border-sm text-secondary"
                        role="status"
                        style={{ position: 'absolute', right: '10px' }}
                     >
                    </div>
                ) :(
                    <IoIosArrowDown
                        size={18}
                        style={{ position: 'absolute', right: '10px', color: '#555' }}
                        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
                    />
                )}
            </div>

            {/* Dropdown Menu */}
            {open && (
                <div
                    style={{
                        position: 'absolute',
                        bottom:'100%',
                        left: 0,
                        width: '100%',
                        background: '#fff',
                        boxShadow: '0 8px 12px 0 rgba(147, 153, 190, 0.12)',
                        border: 'solid 1px #dce8fa',
                        borderRadius: '12px',
                        zIndex: 999,
                        maxHeight: '200px',
                        overflowY: 'auto',
                        padding: '12px',
                        marginBottom:'8px',
                        overflow:'scroll',
                        scrollbarWidth: 'none',
                    }}
                >
                    {authorEmailData?.length > 0 ? (
                        authorEmailData?.map(option => {
                            const displayName = option?.user__name?.charAt(0).toUpperCase()+option?.user__name?.slice(1) || option?.user__email?.split('@')[0] || 'Unknown User';
                            return (
                                <div
                                    key={option.user_id}
                                    onClick={() => toggleSelect(option)}
                                    style={{
                                        padding: '8px 10px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        marginBottom: '8px',
                                        background: isSelected(option) ? '#eef0ff' : '#fff',
                                        color: isSelected(option) ? '#48569a' : '#474747',
                                        borderRadius: '6px'
                                    }}
                                >
                                    <Avatar
                                        src={option.avatarUrl}
                                        name={displayName}
                                        size="34"
                                        round={true}
                                        style={{ marginRight: '12px', fontSize: '16px' }}
                                    />
                                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                        <div style={{ fontWeight: '500', fontSize: '14px', lineHeight: '1.2' }}>
                                            {displayName}
                                        </div>
                                        <div style={{ fontSize: '14px', color: '#7a7a7a', lineHeight: '1.2' }}>
                                            {option.user__email}
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div style={{ padding: '8px 10px', color: '#888', fontSize: '14px' }}>
                            No results found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}